/**
 * Builds an SSO URL pointing at the receiving app's `/sso` route.
 *
 * Tokens are placed in the URL fragment (`#access=...&refresh=...`) rather
 * than the query string so the refresh token never reaches server-side access
 * logs (Application Insights, CloudWatch, web-server logs). Receivers wipe
 * the fragment via `history.replaceState` immediately after reading.
 *
 * If no access token is supplied, the bare base URL is returned (caller will
 * land on `/sso` and the receiver will redirect to login).
 */
export function buildSsoUrl(
  baseUrl: string,
  accessToken: string | null | undefined,
  refreshToken?: string | null,
): string {
  if (!accessToken) return baseUrl;

  const parts = [`access=${encodeURIComponent(accessToken)}`];
  if (refreshToken) {
    parts.push(`refresh=${encodeURIComponent(refreshToken)}`);
  }
  return `${baseUrl}/sso#${parts.join('&')}`;
}
